module.exports = __webpack_public_path__ + "static/media/jetpress-logo-dark.b23f339a.svg";